import type { SetupReadinessVerdict } from '../../../../shared/lib/setupRevision';
import type { MappingProjectReadinessStatus } from './readinessResult';

/**
 * Translates what the mapping readiness check reports into the verdict the
 * setup-revision checkpoint understands. This module is the one place the
 * mapping feature and the shared revision machine meet, so the shared layer
 * stays free of feature types.
 *
 * `unavailable` passes rather than waits: with no Revit runtime readiness was
 * never measured, so it raises no objection to the setup that was saved, and
 * reporting `pending` would leave the revision waiting on an answer that is
 * never coming.
 */
const VerdictByStatus: Record<MappingProjectReadinessStatus, SetupReadinessVerdict> = {
  checking: 'pending',
  repairing: 'pending',
  ready: 'verified',
  blocked: 'failed',
  unavailable: 'verified',
};

export const resolveMappingReadinessVerdict = (
  status: MappingProjectReadinessStatus
): SetupReadinessVerdict => VerdictByStatus[status];
